import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useLocation } from "react-router-dom";
import "./mycreatedpolls.scss";
import useWeb3 from "../../hooks/useWeb3";
// import { useWeb3React } from "@web3-react/core";
import Loader from "../../hooks/loader";
import { useTranslation } from "react-i18next";
import { LIGHT_THEME } from "../../utils/constants";
import { getFormatedWeb3Address, formatNumbers, renderOptions, convertFromMweiToFIxed, convertFromWei, convertFromWeiEthers, getTokenSymbol, getMarketToken, isStableTokenSymbol } from "../../utils/helpers";
import { useTheme } from "../../contexts/ThemeProvider";
import { MARKET_STATUS, MARKET_STATUS_BACKGROUNDS, MARKET_STATUS_TEXT_COLORS } from "../../utils/MarketStatus";
import PoolTimerUI from "../DetailPage/PoolTimerUI";
import CustomPagination from "../CustomPagination";
import LoaderTable from "../../hooks/loaderTable";
import { postToggleFollow, getFollowCheck, fetchUserProfilePools, getFollowStats } from "../../utils/services";
import { notifyError } from "../Toast";
import { useRecoilValue } from "recoil";
import { rainPriceInUsdt, userSmartAccount } from "../RecoilAtom";
import { DEFAULT_ERROR_HEADING } from "../../utils/ConstantMessages";
import { useEoaAccount } from "../../hooks/useEoaAccount";
import SEO from "../SEO";
import { detailPath } from "../../constants/Routes";

const UserProfile = () => {
  const { theme } = useTheme();
  const [pools, setPools] = useState([]);
  const { t } = useTranslation();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const web3 = useWeb3();
  const { account } = useEoaAccount();
  const [activeKey, setActiveKey] = useState("Markets Created");
  const rainPriceInDollar = useRecoilValue(rainPriceInUsdt);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const profileId = queryParams.get("id");
  const [userprofile, setUserProfile] = useState("");
  const [totalUserPnl, setTotalUserPnl] = useState(0);
  const [publicpools, setPublicPools] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isReferralCopied, setIsReferralCopied] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(3);
  const [totalCount, setTotalCount] = useState(0);
  const [message, setMessage] = useState("");
  const [userAccount, setUserAccount] = useState("");
  const [pollStatus, setPollStatus] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [totalVolume, setTotalVolume] = useState(0)
  const [isFollowing, setIsFollowing] = useState(false);
  const [followingCount, setFollowingCount] = useState(0);
  const [followersCount, setFollowersCount] = useState(0);
  const loggedInUserId = localStorage.getItem("userId");
  const smartAccount = useRecoilValue(userSmartAccount);
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (location.state?.openHistoryTab) {
      setActiveKey("History");
      const mainTabsContainer = document.querySelector(".tabsmain");
      if (mainTabsContainer) {
        mainTabsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location]);
  useEffect(() => {
    if (profileId) {
      fetchFollowStatsData();
    }
  }, [profileId]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const fetchFollowStatsData = async () => {
    try {
      const followStatus = await getFollowCheck(profileId);
      setIsFollowing(followStatus?.data?.isFollowing || false);
      const followstats = await getFollowStats(profileId);
      setFollowersCount(followstats?.followersCount || 0);
      setFollowingCount(followstats?.followingCount || 0);
    } catch (error) {
      console.error("Error loading follow data:", error);
    }
  };

  const getPoolsByCreator = async (offset, type = "publicPools") => {
    if (!profileId) return;
    setIsTableLoading(true);

    try {
      const data = await fetchUserProfilePools(profileId, offset, type);
      setTotalCount(data?.userCreatedMarkets?.count);
      setTotalPages(data?.userCreatedMarkets?.pages);
      setUserProfile(data?.userProfile);
      setUserAccount(data?.userProfile?.walletAddress);
      setTotalVolume(data?.userTotalVolumeResult?.totalVolume);
      setTotalUserPnl(data?.userPnl?.pnl);
      setPublicPools(data?.userCreatedMarkets?.pools);
      setPools(data?.pools);
    } catch (error) {
      console.error("Error fetching pools:", error);
    } finally {
      setIsTableLoading(false);
    }
  };

  useEffect(() => {
    getPoolsByCreator(currentPage, "publicPools");
  }, [profileId, currentPage]);

  const handleSelect = (key) => {
    setActiveKey(key);
  };

  const handleCopyClick11 = (text, userAccount) => {
    const textToCopy = text;
    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = textToCopy;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);
    if (userAccount) {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    } else {
      setIsReferralCopied(true);
      setTimeout(() => {
        setIsReferralCopied(false);
      }, 1000);
    }


  };

  const handleToggleFollow = async () => {
    if (!smartAccount) {
      notifyError(DEFAULT_ERROR_HEADING, "Please login to continue.");
      return;
    }
    setIsLoading(true)
    try {
      const res = await postToggleFollow(profileId);
      setIsFollowing(prev => {
        const newStatus = !prev;
        setFollowersCount(count => newStatus ? count + 1 : count - 1);
        return newStatus;
      });
    } catch (error) {
      console.error("Error toggling follow:", error);
    }
    finally {
      setIsLoading(false)

    }
  };

  const isMyOwnProfile = profileId?.toLocaleLowerCase() === loggedInUserId?.toLowerCase();

  return (
    <>
      <SEO
        url='https://www.rain.one/user-profile'
      />
      {loader && <Loader text={message} />}
      <section className="mycreatedpolls userprofiles-section">
        <div className="custom-container">
          <div className="upper-profile">
            <div className="left-profile">
              <div className="main-img">
                <img
                  src={userprofile?.profilePic || "/assets/placeholder.png"}
                  alt="img"
                  className="img-fluid"
                />
              </div>
              <div className="right-text">

                <h6>{userprofile?.name}</h6>
                <p>
                  {t("Smart Wallet")}
                  <span style={{ color: "#DAD9D9" }}>
                    {userAccount ?
                      `${getFormatedWeb3Address(userAccount, true)}`
                      : "---"}
                  </span>

                  {userAccount &&
                    <a onClick={() => handleCopyClick11(userAccount, true)}>
                      {isCopied ? (
                        <svg className='copysvg' xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M13 3L4.75 11L1 7.36364" stroke="#E6FF00" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_635_5718)">
                            <path
                              d="M10.0002 4.00006H5.00024C4.44796 4.00006 4.00024 4.44778 4.00024 5.00006V10.0001C4.00024 10.5523 4.44796 11.0001 5.00024 11.0001H10.0002C10.5525 11.0001 11.0002 10.5523 11.0002 10.0001V5.00006C11.0002 4.44778 10.5525 4.00006 10.0002 4.00006Z"
                              stroke="#E5FE00"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M2.00024 8.00006C1.45024 8.00006 1.00024 7.55006 1.00024 7.00006V2.00006C1.00024 1.45006 1.45024 1.00006 2.00024 1.00006H7.00024C7.55024 1.00006 8.00024 1.45006 8.00024 2.00006"
                              stroke="#E5FE00"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_635_5718">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                    </a>
                  }
                </p>
                <div className="social-links">
                  {userprofile?.twitterLink &&
                    <a
                      target="_blank"
                      href={
                        userprofile?.twitterLink?.includes("http")
                          ? userprofile.twitterLink
                          : `https://x.com/${userprofile?.twitterLink}`
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_1010_31669)">
                          <path
                            d="M8.91353 1.76123H10.4573L7.08466 5.6159L11.0523 10.8612H7.94566L5.51246 7.67996L2.72833 10.8612H1.18366L4.791 6.73823L0.984863 1.76123H4.17033L6.36973 4.66903L8.91353 1.76123ZM8.37173 9.93723H9.22713L3.70553 2.6367H2.7876L8.37173 9.93723Z"
                            fill="#DAD9D9"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1010_31669">
                            <rect
                              width="11.2"
                              height="11.2"
                              fill="white"
                              transform="translate(0.399902 0.711182)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  }
                  {userprofile?.telegramLink &&
                    <a
                      href={
                        userprofile?.telegramLink?.includes("http")
                          ? userprofile.telegramLink
                          : `https://t.me/${userprofile?.telegramLink}`
                      }
                      target="_blank"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <path
                          d="M8.13464 5.10509C8.42088 4.81032 8.70505 4.12254 7.51236 4.95771C6.39824 5.74733 5.27654 6.52556 4.14743 7.29232C3.97549 7.37237 3.78961 7.41583 3.60096 7.42005C3.41231 7.42427 3.22478 7.38919 3.04963 7.31688C2.33402 7.09581 1.49862 6.80105 1.49862 6.80105C1.49862 6.80105 0.928198 6.43206 1.90465 6.03905C1.90465 6.03905 6.03291 4.29449 7.46466 3.67987C8.01329 3.43423 9.87441 2.6482 9.87441 2.6482C9.87441 2.6482 10.7337 2.30377 10.6621 3.13947C10.6383 3.48336 10.4474 4.68804 10.2566 5.98992C9.96983 7.83272 9.65973 9.848 9.65973 9.848C9.65973 9.848 9.61202 10.413 9.2065 10.5112C8.77242 10.5036 8.353 10.3481 8.01381 10.0691C7.9184 9.99538 6.22426 8.88949 5.60354 8.34909C5.54038 8.30503 5.48909 8.24528 5.4544 8.17533C5.41976 8.10537 5.40281 8.02752 5.40519 7.94902C5.40758 7.87053 5.4292 7.79395 5.46804 7.72635C5.50688 7.6588 5.56169 7.60241 5.62739 7.56252C6.47877 6.76041 7.31464 5.94111 8.13464 5.10509Z"
                          fill="#DAD9D9"
                        />
                      </svg>
                    </a>
                  }
                  {userprofile?.discordLink &&
                    <a
                      href={
                        userprofile?.discordLink?.includes("http")
                          ? userprofile.discordLink
                          : `https://discord.gg/${userprofile?.discordLink}`
                      }
                      target="_blank"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M4.73537 10.9436C7.51642 12.029 9.88309 12.2404 12.565 10.551C12.5454 10.5805 12.0148 11.3665 10.6197 11.7693C10.9145 12.1721 11.3173 12.6338 11.3173 12.6338C12.2113 12.6338 13.0857 12.3784 13.8422 11.8872C14.4317 11.4942 14.7657 10.8163 14.6969 10.1089C14.579 8.90049 14.2941 7.72154 13.852 6.59174C13.292 5.11807 11.9461 4.0963 10.384 3.94892C10.2464 3.93909 10.1482 3.93909 10.0892 3.93909L9.93206 4.09627C11.7299 4.60715 12.624 5.40294 12.6436 5.43243C9.88291 4.03733 6.62117 4.0177 3.8408 5.37348C3.8408 5.37348 4.72502 4.49909 6.68009 4.03733L6.5622 3.91943C6.35587 3.91943 6.15938 3.93909 5.95308 3.96855C4.50886 4.21416 3.30046 5.20644 2.77975 6.57205C2.32781 7.751 2.03308 8.98889 1.92502 10.2464C1.86607 10.9145 2.18046 11.5728 2.73063 11.9559C3.45764 12.4373 4.3222 12.6928 5.19659 12.6928C5.19659 12.6928 5.55026 12.231 5.90396 11.8184C4.57764 11.4254 4.0373 10.6394 4.02747 10.6099L4.27708 10.7374C4.42629 10.8136 4.57927 10.8827 4.73537 10.9436ZM6.2773 10.0893C5.63869 10.0696 5.13764 9.52926 5.1573 8.88083C5.17696 8.27171 5.66818 7.78049 6.2773 7.76083C6.9159 7.78049 7.41696 8.32083 7.3973 8.96926C7.36781 9.57841 6.88642 10.0696 6.2773 10.0893ZM10.2857 10.0893C9.6471 10.0696 9.14604 9.52926 9.1657 8.88083C9.18536 8.27171 9.67659 7.78049 10.2857 7.76083C10.9243 7.78049 11.4254 8.32083 11.4057 8.96926C11.3861 9.57841 10.8948 10.0696 10.2857 10.0893Z"
                          fill="#DAD9D9"
                        />
                      </svg>
                    </a>
                  }
                </div>
              </div>
            </div>
            <div className="right-profile">
              <div className="multi-values">
                <div className="single-value">
                  <p>{t("Total PnL")}</p>
                  {/* <h6 style={{ color: "var(--green-text)" }}>{convertFromMwei(totalUserPnl)}
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM10 16.875C8.64026 16.875 7.31105 16.4718 6.18046 15.7164C5.04987 14.9609 4.16868 13.8872 3.64833 12.6309C3.12798 11.3747 2.99183 9.99237 3.2571 8.65875C3.52238 7.32513 4.17716 6.10013 5.13864 5.13864C6.10013 4.17716 7.32514 3.52237 8.65876 3.2571C9.99238 2.99183 11.3747 3.12798 12.631 3.64833C13.8872 4.16868 14.9609 5.04987 15.7164 6.18045C16.4718 7.31104 16.875 8.64025 16.875 10C16.8729 11.8227 16.1479 13.5702 14.8591 14.8591C13.5702 16.1479 11.8227 16.8729 10 16.875ZM11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75ZM8.75 6.5625C8.75 6.37708 8.80499 6.19582 8.908 6.04165C9.01101 5.88748 9.15743 5.76732 9.32874 5.69636C9.50004 5.62541 9.68854 5.60684 9.8704 5.64301C10.0523 5.67919 10.2193 5.76848 10.3504 5.89959C10.4815 6.0307 10.5708 6.19775 10.607 6.3796C10.6432 6.56146 10.6246 6.74996 10.5536 6.92127C10.4827 7.09257 10.3625 7.23899 10.2084 7.342C10.0542 7.44502 9.87292 7.5 9.6875 7.5C9.43886 7.5 9.20041 7.40123 9.02459 7.22541C8.84878 7.0496 8.75 6.81114 8.75 6.5625Z" fill="white" />
                  </svg>
                  </h6> */}
                  <h6
                    style={{
                      color: formatNumbers(+convertFromWei(totalUserPnl)) > 0 ? "var(--green-text)" : "var(--logout-text)",
                      margin: "0",
                    }}
                  >
                    {(formatNumbers(+convertFromWei(totalUserPnl)))}
                  </h6>
                </div>
                <div className="single-value">
                  <p>{t("Total Volume")}</p>
                  <h6>$
                    {(formatNumbers(+convertFromWei(totalVolume)))}
                  </h6>
                </div>
                <div className="single-value">
                  <p>{t("Followers")}</p>
                  <h6>{followersCount}</h6>
                </div>
                <div className="single-value">
                  <p>{t("Following")}</p>
                  <h6>{followingCount}</h6>
                </div>
              </div>
              <div className="inline-btns">
                {!isMyOwnProfile && (
                  <button
                    onClick={handleToggleFollow}
                    className={isFollowing ? "btn-edit-unfollow" : "btn-edit"}
                    disabled={isLoading}
                  >
                    <span className="follow-text">
                      {isLoading ? (
                        <span className="spinner-border spinner-border-sm" role="status" />
                      ) : isFollowing ? (
                        t("Unfollow")
                      ) : (
                        t("Follow")
                      )}
                    </span>
                  </button>

                )}
              </div>
            </div>
          </div>
          <div className="tabsmain">
            <div className="right-side-filters">
              <div className="option-field">
                {/* <div className="inputdropdown">
                  <Dropdown show>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <input
                        type="text"
                        placeholder="Search Markets by keywords"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item disabled>
                        <span>Loading...</span>
                      </Dropdown.Item>
                      <Dropdown.Item href={detailPath(1)}>
                        <span>Example Market Question</span>
                      </Dropdown.Item>
                      <Dropdown.Item disabled>
                        <span>No results found</span>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div> */}

                {/* Example Clear Icon */}
                {/* <svg
                  className="search-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M13.5 4.5L4.5 13.5"
                    stroke="#DAD9D9"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.5 4.5L13.5 13.5"
                    stroke="#DAD9D9"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg> */}

                {/* Example Search Icon */}
                {/* <svg
                  className="search-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M15.1479 14.3519L11.6274 10.8321C12.6478 9.60705 13.1566 8.03577 13.048 6.44512C12.9394 4.85447 12.2218 3.36692 11.0443 2.29193C9.8669 1.21693 8.32035 0.637251 6.72641 0.673476C5.13247 0.709701 3.61386 1.35904 2.48648 2.48642C1.3591 3.6138 0.709762 5.13241 0.673537 6.72635C0.637312 8.32029 1.21699 9.86684 2.29199 11.0443C3.36699 12.2217 4.85453 12.9394 6.44518 13.048C8.03583 13.1566 9.60711 12.6477 10.8322 11.6273L14.352 15.1479C14.4043 15.2001 14.4663 15.2416 14.5346 15.2699C14.6029 15.2982 14.6761 15.3127 14.75 15.3127C14.8239 15.3127 14.8971 15.2982 14.9654 15.2699C15.0336 15.2416 15.0957 15.2001 15.1479 15.1479C15.2002 15.0956 15.2417 15.0336 15.2699 14.9653C15.2982 14.897 15.3128 14.8238 15.3128 14.7499C15.3128 14.676 15.2982 14.6028 15.2699 14.5345C15.2417 14.4663 15.2002 14.4042 15.1479 14.3519ZM1.81248 6.87492C1.81248 5.87365 2.10939 4.89487 2.66566 4.06234C3.22194 3.22982 4.01259 2.58094 4.93764 2.19778C5.86269 1.81461 6.88059 1.71435 7.86262 1.90969C8.84465 2.10503 9.7467 2.58718 10.4547 3.29519C11.1627 4.00319 11.6449 4.90524 11.8402 5.88727C12.0355 6.8693 11.9353 7.8872 11.5521 8.81225C11.169 9.7373 10.5201 10.528 9.68755 11.0842C8.85503 11.6405 7.87625 11.9374 6.87498 11.9374C5.53278 11.9359 4.24597 11.4021 3.29689 10.453C2.34781 9.50392 1.81397 8.21712 1.81248 6.87492Z"
                    fill="#DAD9D9"
                  />
                </svg> */}
              </div>
              {/* <Dropdown className="sortdropdownnew">
                <Dropdown.Toggle id="dropdown-basic" className="dropdown-btn">
                  Sort By <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M8.60172 15.5855L3.53922 10.523C3.43367 10.4174 3.37437 10.2743 3.37437 10.125C3.37437 9.97573 3.43367 9.83258 3.53922 9.72703C3.64477 9.62148 3.78792 9.56219 3.93719 9.56219C4.08645 9.56219 4.22961 9.62148 4.33516 9.72703L8.43719 13.8298L8.43719 2.8125C8.43719 2.66332 8.49645 2.52024 8.60194 2.41475C8.70743 2.30926 8.8505 2.25 8.99969 2.25C9.14887 2.25 9.29195 2.30926 9.39744 2.41475C9.50292 2.52024 9.56219 2.66332 9.56219 2.8125L9.56219 13.8298L13.6642 9.72703C13.7698 9.62148 13.9129 9.56219 14.0622 9.56219C14.2115 9.56219 14.3546 9.62148 14.4602 9.72703C14.5657 9.83258 14.625 9.97573 14.625 10.125C14.625 10.2743 14.5657 10.4174 14.4602 10.523L9.39766 15.5855C9.34542 15.6378 9.28338 15.6793 9.21509 15.7076C9.14681 15.7359 9.07361 15.7504 8.99969 15.7504C8.92577 15.7504 8.85257 15.7359 8.78428 15.7076C8.716 15.6793 8.65396 15.6378 8.60172 15.5855Z" fill="#DAD9D9" />
                  </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item className="dropitem">
                    Latest
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown className="sortdropdownnew">
                <Dropdown.Toggle id="dropdown-basic" className="dropdown-btn">
                  All Markets  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#DAD9D9" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item className="dropitem">
                    LIVE
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}

            </div>
            <Tabs
              onSelect={handleSelect}
              id="controlled-tab-example"
              activeKey={activeKey}
              className="bannertabs"
            >

              <Tab eventKey="Markets Created" title={t("Markets Created")}>
                <div className="tabsmain">
                  <div className={publicpools && publicpools?.length > 0 ? "inner-tab-content" : "inner-tab-content nodatafoundstyling"}>
                    {isTableLoading ? (
                      <div className="pb-5 pt-5 text-center">
                        <LoaderTable />
                      </div>
                    ) : (
                      publicpools && publicpools.length > 0 ? (
                        publicpools.map((pool, index) => {
                          const volumeDecimal = convertFromWeiEthers(pool.totalVolume, pool?.token?.tokenDecimals);

                          return (
                            <a href={detailPath(pool._id)} className="inner-row" key={index}>
                              <div className="upper-area">
                                <p>
                                  {pool?.tags?.length > 0 ? (
                                    <>
                                      {pool.tags.slice(0, 2).join(", ")}
                                      {pool.tags.length > 2 && ` +${pool.tags.length - 2} More`}
                                    </>
                                  ) : (
                                    t("")
                                  )}
                                </p>
                                <span className="livetext" style={{ backgroundColor: MARKET_STATUS_BACKGROUNDS[pool.status], color: MARKET_STATUS_TEXT_COLORS[pool.status], }}>{t(MARKET_STATUS[pool.status])}</span>
                              </div>
                              <h4 className="question-text">{pool.question}</h4>
                              <div className="mid-options">
                                {renderOptions(
                                  pool.options,
                                  2,
                                  false,
                                  theme
                                )}
                              </div>
                              <div className="bottom-inline">
                                <div className="single-inline">
                                  <p>{t('Volume')}</p>
                                  <h6>${+volumeDecimal ?
                                    formatNumbers(
                                      isStableTokenSymbol(pool?.token?.tokenSymbol)
                                        ? +volumeDecimal
                                        : +volumeDecimal * +rainPriceInDollar
                                    )
                                    : "0"
                                  }</h6>
                                </div>
                                <div className="single-inline">
                                  <p>{t("Trade With")}</p>
                                  <h6>{getTokenSymbol(pool?.token?.tokenSymbol, true)} {getMarketToken(pool?.token).label}</h6>
                                </div>
                                <div className="single-inline">
                                  <PoolTimerUI
                                    poolstart={pool?.startDate}
                                    poolend={pool?.endDate}
                                    poolsdetail={pool}
                                    setPollStatus={setPollStatus}
                                    setIsDisabled={setIsDisabled}
                                    endedTextColor={theme === LIGHT_THEME ? "#212121" : "#FFFFFF"}
                                  />
                                </div>
                              </div>
                            </a>
                          );
                        })
                      ) : (
                        <div className="whennopolls">
                          <svg xmlns="http://www.w3.org/2000/svg" width="113" height="112" viewBox="0 0 113 112" fill="none">
                            <path d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z" fill="#2F2F2F" />
                            <path d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z" fill="#353535" />
                            <path d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z" fill="#2F2F2F" />
                            <path d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z" fill="#3E3E3E" />
                            <path d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z" fill="#2F2F2F" />
                            <path d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z" fill="#3E3E3E" />
                            <path d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z" fill="#393939" />
                          </svg>
                          <p>{t('No Markets Found')}</p>
                        </div>
                      )
                    )}

                  </div>
                  {!isTableLoading &&
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />
                  }
                </div>
              </Tab>
              {/* <Tab
                eventKey="Participated Markets"
                title={t("Participated Markets")}
              >
                <div className="tabsmain">
                  <div className={pools && pools?.length > 0 ? "inner-tab-content" : "inner-tab-content nodatafoundstyling"}>
                    {isTableLoading ? (
                      <div className="pb-5 pt-5 text-center">
                        {
                          theme === 'dark' ? <img width={50} className="mt-n4" src="/loader.svg" alt="img" /> :
                            <img width={50} className="mt-n4 loader_rotate" src="/loaderlight.svg" alt="img" />
                        }
                      </div>
                    ) : (
                      pools && pools.length > 0 ? (
                        pools.map((pool, index) => {
                          const totalVolume = pool?.totalVolume ? String(pool.totalVolume) : "0";
                          const volumeDecimal = convertFromWei(totalVolume, 'ether');

                          return (
                            <a href={detailPath(pool._id)} className="inner-row" key={index}>
                              <div className="upper-area">
                                <p>
                                  {pool?.tags?.length > 0 ? (
                                    <>
                                      {pool.tags.slice(0, 2).join(", ")}
                                      {pool.tags.length > 2 && ` +${pool.tags.length - 2} More`}
                                    </>
                                  ) : (
                                    t("No tags available")
                                  )}
                                </p>
                                <span className="livetext" style={{ backgroundColor: MARKET_STATUS_BACKGROUNDS[pool.status], color: MARKET_STATUS_TEXT_COLORS[pool.status], }}>{t(MARKET_STATUS[pool.status])}</span>
                              </div>
                              <h4 className="question-text">{pool.question}</h4>
                              <div className="mid-options">
                                {renderOptions(
                                  pool.options,
                                  2,
                                  false,
                                  theme
                                )}
                              </div>
                              <div className="bottom-inline">
                                <div className="single-inline">
                                  <p>{t('Volume')}</p>
                                  <h6>${volumeDecimal ? formatNumbers(+volumeDecimal) : "0"}</h6>
                                </div>
                                <div className="single-inline">
                                  <PoolTimerUI
                                    poolstart={pool?.startDate}
                                    poolend={pool?.endDate}
                                    poolsdetail={pool}
                                    setPollStatus={setPollStatus}
                                    setIsDisabled={setIsDisabled}
                                    endedTextColor={theme === LIGHT_THEME ? "#212121" : "#FFFFFF"}
                                  />
                                </div>
                              </div>
                            </a>
                          );
                        })
                      ) : (
                        <div className="whennopolls">
                          <svg xmlns="http://www.w3.org/2000/svg" width="113" height="112" viewBox="0 0 113 112" fill="none">
                            <path d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z" fill="#2F2F2F" />
                            <path d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z" fill="#353535" />
                            <path d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z" fill="#2F2F2F" />
                            <path d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z" fill="#3E3E3E" />
                            <path d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z" fill="#2F2F2F" />
                            <path d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z" fill="#3E3E3E" />
                            <path d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z" fill="#393939" />
                          </svg>
                          <p>{t('No Markets Found')}</p>
                        </div>
                      )
                    )}

                  </div>
                  {!isTableLoading &&
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />
                  }
                </div>
              </Tab> */}
            </Tabs>
          </div>
        </div>
      </section>

    </>
  );
};

export default UserProfile;